import React from "react";
import styled, { useTheme } from "styled-components";
import { FlexColumn } from "../../../../Common/Styles";
import { Components } from "@thisgorilla/primate-ds";

const AdUnit = () => {
  const { typography, Color } = useTheme();
  return (
    <MainContainer $gapInPx={10}>
      <Components.Text
        style={{ tokenStyle: typography.Heading.S }}
        text={"Sponsored"}
        lineHeight="line-height-400"
        fontWeight="font-weight-semibold"
      />
      <Container $gapInPx={8}>
        <AdImageContainer src="/images/ad-image.png" />
        <FlexColumn $gapInPx={0}>
          <Components.Text
            style={{ tokenStyle: typography.Heading.XXS }}
            text={"Optimise your workflow now!"}
            lineHeight="line-height-50"
            fontWeight="font-weight-semibold"
          />
          <Components.Text
            style={{ tokenStyle: typography.Body.S }}
            text={"monday.com"}
            lineHeight="line-height-50"
            color={Color.text["text-secondary"].value}
          />
        </FlexColumn>
      </Container>
    </MainContainer>
  );
};

export default AdUnit;

const Container = styled(FlexColumn)`
  padding: ${({ theme }) => theme.spacing["spacing-3"].value}rem
    ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  border-radius: ${({ theme }) => theme.radius["radius-xs"].value}rem;
`;

const AdImageContainer = styled.img`
  width: 100%;
  border-radius: ${({ theme }) => theme.radius["radius-xs"].value}rem;
  background: ${({ theme }) =>
    theme.Color.elevation.surface["surface-primary"].value};
  min-height: 140px;
  object-fit: contain;
`;

const MainContainer = styled(FlexColumn)`
  padding: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  border-radius: ${({ theme }) => theme.radius["radius-xs"].value}rem;
  box-shadow: ${({ theme }) => theme.boxShadows["box-shadow-s"]};
  border: 1px solid
    ${({ theme }) => theme.Color.border["ui-border-subtle"].value};
`;
